import * as React from 'react'
import { useCallback, useMemo, useEffect, useState } from 'react'

import {
  BulkActionsProps,
  BulkActionAddNoteButton,
  useBulkActionContext,
  BulkAddNotesModel,
} from '@user/components/xGrid'
import { useAppSelector } from '@user/store/hooks'
import { selectAllLeads, selectLeadById } from '@user/store/lead'
import { NotesDrawer, useNotesDrawer } from '../../LeadCard/NotesDrawer'
import { ENTITY_TYPES } from '@sales-center/common'
import { useSelector } from 'react-redux'

type Props = BulkActionsProps & { hasPermission: boolean }

export function LeadBulkAddNote(props: Props) {
  const { hasPermission, selectedRows } = props
  const [showBulkAddModel, setShowBulkAddModel] = useState(false)
  const { dispatch } = useBulkActionContext()
  const allLeads = useSelector(selectAllLeads)

  const notesState = useNotesDrawer({
    canUpdate: hasPermission,
    detailPage: true,
  })

  const isMultipleSelected = selectedRows.size > 1 ? true : false

  useEffect(() => {
    if (!isMultipleSelected && !notesState.viewNotesModalOpen) {
      dispatch({ type: 'setActive' })
    }
    if (isMultipleSelected && !showBulkAddModel) {
      dispatch({ type: 'setActive' })
    }
  }, [
    notesState.viewNotesModalOpen,
    dispatch,
    showBulkAddModel,
    isMultipleSelected,
  ])

  const ids = useMemo(
    () => [...selectedRows.keys()].map((k) => Number(k)),
    [selectedRows],
  )

  const entityId = ids[0]
  const lead = useAppSelector((state) => selectLeadById(state, entityId))
  const leads = allLeads?.filter((row) => ids?.includes(row?.id))

  const onButtonClick = useCallback(() => {
    if (isMultipleSelected) {
      setShowBulkAddModel(true)
    }
    if (!isMultipleSelected) {
      notesState.showViewNoteModal()
    }
  }, [notesState, isMultipleSelected, setShowBulkAddModel])

  return (
    <>
      <BulkActionAddNoteButton
        hasPermission={hasPermission}
        onButtonClick={onButtonClick}
        recordCount={selectedRows.size}
      />
      {!isMultipleSelected && lead && (
        <NotesDrawer {...notesState} lead={lead} />
      )}
      {isMultipleSelected && (
        <BulkAddNotesModel
          open={showBulkAddModel}
          onClose={() => setShowBulkAddModel(false)}
          entityType={ENTITY_TYPES.Lead}
          data={leads}
        />
      )}
    </>
  )
}
